var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.stepName},[_vm._m(0),_vm._v(" "),_c('AddressForm')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-header"},[_c('p',[_c('strong',[_vm._v("Gefeliciteerd, voortaan ben je Supporter van Testaankoop.")])]),_vm._v(" "),_c('p',[_vm._v("Om toegang te krijgen tot alle diensten, onze magazines en uw welkomstgeschenk te ontvangen, vult u de volgende velden in:")])])
}]

export { render, staticRenderFns }